
export class CampaignModel{
   
    id:number| null;
    campaignName:string;
    active:boolean;
    createDate:string;
    endDate:string;
    campaignFields:CampaignFields[];

    getDefaultFields(){
        return [{displayName:"Smart Phone",fieldName:"HaveSmartPhone",bonusValue:0,visibility:false,campId:0,id:0},
        {displayName:"Mobile Type",fieldName:"MobileType",bonusValue:0,visibility:false,campId:0,id:0},
        {displayName:"Where did you hear about Mobilawy ?",fieldName:"HearAbout",bonusValue:0,visibility:false,campId:0,id:0},
        {displayName:"Car Brand",fieldName:"BrandId",bonusValue:0,visibility:false,campId:0,id:0},
        {displayName:"Car Model",fieldName:"ModelId",bonusValue:0,visibility:false,campId:0,id:0},
        {displayName:"Which Mobil Oil Product?",fieldName:"OilProduct",bonusValue:0,visibility:false,campId:0,id:0},
      

    ];
    }
}

export class CampaignFields{
    
    id:number| null;
    fieldName:string;
    displayName:string;

    visibility:boolean;
    bonusValue:number;
    campId:number;
}

